module.exports = __webpack_public_path__ + "static/img/9.b0849ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/7/zh/9.png
// module id = 5iR2
// module chunks = 0